import styled from 'styled-components';
import { sizes } from '../../styles/theme/devices';

export const TipContainer = styled.span`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 20;
`;

export const TipInformationsBalloon = styled.div`
  align-items: center;
  background: #000000;
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15), 0px 4px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  font-family: 'Poppins', sans-serif;
  justify-content: center;
  position: absolute;
  padding: 10px;
  bottom: 28px;

  @media (max-width: ${sizes.mobileL}) {
    right: -10px;
  }

  & > p {
    color: #ffffff;
    font-family: inherit;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    text-align: center;
    width: 285px;
  }
`;

export const TipInformationBalloonArrow = styled.i`
  position: absolute;
  top: -18px;
  left: -3px;
`;
